import { styled } from '@mui/material/styles';

import { Theme, px, rem } from '../../theme';
import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';

export const StyledBody = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        row-gap: ${theme.tggSpacing(rem(1.5), 3.75)};
        ${theme.breakpoints.up('desktop')} {
            display: grid;
            padding: ${theme.tggSpacing(px(40), 10)};
        }
        /* stylelint-disable-next-line unit-allowed-list */
        padding: ${theme.tggSpacing([rem(2.4), rem(3)], [10, 7.5])};
	`}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_25_bold_desktop_31};
    ${({ theme }: { theme: Theme }) => `
        padding-left: ${theme.tggSpacing(0, 0)};
        margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};
        text-align: left;
        ${theme.breakpoints.up('desktop')} {
            text-align: center;
        }
	`}
`;

export const StyledItem = styled('article')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: row;
        padding-right: ${theme.tggSpacing(px(30), 7.5)};
	`}
`;

export const StyledOpeningHoursItem = styled('article')`
    display: flex;
    flex-direction: row;
    grid-row: 1/3;
    grid-column: 2;
`;

export const StyledContent = styled('div')``;

export const StyledContentHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_19_bold_desktop_21};
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            padding-top: ${theme.tggSpacing(rem(0.25), 0.625)};
        }
	`}
`;

export const StyledDescription = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(rem(0.125), 0.3125)};
        margin-bottom: ${theme.tggSpacing(0, 0)};
	`}
`;

export const StyledAddress = styled('address')`
    margin-top: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(0.125), 0.3125)};
    margin-bottom: ${({ theme }: { theme: Theme }) => theme.tggSpacing(0, 0)};
    font-style: unset;
`;

export const StyledIcon = styled('div')`
    ${({ theme }: { theme: Theme }) => `
            display: flex;
        align-items: center;
        width: ${theme.tggSpacing(rem(4), 10)};
        height: ${theme.tggSpacing(rem(4), 10)};
        padding: ${theme.tggSpacing(rem(0.5), 1.25)};
        margin-right: ${theme.tggSpacing(px(15), 4)};
        border: ${theme.tggSpacing(rem(0.25), 0.625)}
            ${theme.palette.grey[900]};
        border-radius: 100%;

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(6), 15)};
            height: ${theme.tggSpacing(rem(6), 15)};
            padding: ${theme.tggSpacing(rem(0.75), 1.875)};
        }
	`}
`;

export const StyledOpeningTimeAndDayWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`;

export const StyledOpeningTimesDay = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        grid-column-start: 2;
        grid-column-end: 3;
        padding-right: ${theme.tggSpacing(rem(2), 5)};
        ${theme.breakpoints.up('desktop')} {
            padding-right: ${theme.tggSpacing(rem(4), 10)};
        }
	`}
`;

export const StyledOpeningTimesTime = styled(Paragraph)`
    grid-column-start: 3;
    grid-column-end: 4;
`;
